<div class="field-dialog">
  <mat-toolbar class="field-dialog__header" fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="field-dialog__header__title" *ngIf="!location?.id">Adicionar localização</h2>
    <h2 class="field-dialog__header__title" *ngIf="location?.id">{{ location.name }}</h2>

    <button class="field-dialog__header__close" mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </mat-toolbar>

  <mat-tab-group
    class="field-dialog__content"
    [(selectedIndex)]="selectedTabIndex"
    (selectedTabChange)="onTabChange($event)"
  >
    <mat-tab>
      <ng-template mat-tab-label>
        <span>{{ 'LOCATIONS.DIALOG.TABS.GENERAL' | translate }}</span>
        <mat-icon *ngIf="locationForm.invalid && selectedTabIndex !== 0">error</mat-icon>
      </ng-template>
      <ng-template matTabContent>
        <disclaimer *ngIf="isViewMode" [message]="'LOCATIONS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>
        <tab-general [locationForm]="locationForm" [isViewMode]="isViewMode"></tab-general>
      </ng-template>
    </mat-tab>

    <mat-tab [label]="'LOCATIONS.DIALOG.TABS.TAB_LOCATION.TITLE' | translate" [disabled]="!location?.id">
      <ng-template matTabContent>
        <disclaimer *ngIf="isViewMode" [message]="'LOCATIONS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>
        <tab-location
          [selectedTabIndex]="selectedTabIndex"
          [locationForm]="locationForm"
          [isViewMode]="isViewMode"
        ></tab-location>
      </ng-template>
    </mat-tab>

    <mat-tab [label]="'LOCATIONS.DIALOG.TABS.COMPANIES' | translate" [disabled]="!location?.id">
      <disclaimer *ngIf="isViewMode" [message]="'LOCATIONS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>
      <tab-new-providers
        [serviceProvidersFormArray]="locationForm.get('serviceProviders')"
        [isViewMode]="isViewMode"
        [loadingProviders]="loadingProviders"
      ></tab-new-providers>
    </mat-tab>

    <mat-tab
      [label]="'LOCATIONS.DIALOG.TABS.GROUPS' | translate"
      [disabled]="!location?.id"
      *ngIf="hasEditGroupPermission && hasLocationsPermissionsEnabled"
    >
      <ng-template matTabContent>
        <disclaimer *ngIf="isViewMode" [message]="'LOCATIONS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>
        <tab-groups [isViewMode]="isViewMode" [location]="location"></tab-groups>
      </ng-template>
    </mat-tab>

    <mat-tab [disabled]="!location?.id">
      <ng-template mat-tab-label>
        <span id="links-tab-label">
          {{ 'LOCATIONS.DIALOG.TABS.LINKS' | translate }}<span class="title-badge"></span>
        </span>
      </ng-template>
      <ng-template matTabContent>
        <tab-links [location]="location" [isViewMode]="isViewMode"></tab-links>
      </ng-template>
    </mat-tab>

    <mat-tab [disabled]="!location?.id">
      <ng-template mat-tab-label>
        <span>{{ 'LOCATIONS.DIALOG.TABS.CONTACTS' | translate }}</span>
        <mat-icon *ngIf="locationForm.get('contact').invalid && selectedTabIndex !== 5">error</mat-icon>
      </ng-template>
      <ng-template matTabContent>
        <tab-contacts [contactForm]="locationForm.get('contact')" [isViewMode]="isViewMode"></tab-contacts>
        <disclaimer *ngIf="isViewMode" [message]="'LOCATIONS.PERMISSIONS.NO_EDIT' | translate"> </disclaimer>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

  <div *ngIf="!isViewMode" class="field-dialog__footer" fxLayout="row" fxLayoutAlign="space-between center">
    <button
      class="field-background"
      *ngIf="!location?.id && selectedTabIndex === 0"
      mat-raised-button
      [disabled]="locationForm?.invalid"
      (click)="continue()"
    >
      {{ 'LOCATIONS.DIALOG.BUTTON.CONTINUE' | translate }}
    </button>

    <button
      class="field-background"
      data-cy="dialog-locations-save-button"
      color="primary"
      mat-raised-button
      *ngIf="location?.id"
      [disabled]="locationForm?.invalid || isLoading"
      (click)="saveLocation({ closeDialog: true })"
    >
      {{ 'LOCATIONS.DIALOG.BUTTON.SAVE' | translate }}
    </button>

    <div *ngIf="location?.id">
      <button
        class="archive-location"
        *ngIf="!location.archived"
        mat-icon-button
        (click)="archiveLocation()"
        matTooltip="{{ 'LOCATIONS.DIALOG.BUTTON.ARCHIVE' | translate }}"
        [disabled]="locationForm?.invalid || isLoading"
      >
        <mat-icon>archive</mat-icon>
      </button>

      <button
        class="unarchive-location"
        *ngIf="location.archived"
        mat-icon-button
        (click)="unarchiveLocation()"
        [disabled]="locationForm?.invalid || isLoading"
        matTooltip="{{ 'LOCATIONS.DIALOG.BUTTON.UNARCHIVE' | translate }}"
      >
        <mat-icon>unarchive</mat-icon>
      </button>
    </div>
  </div>
</div>
